/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Analytics_Board_EmptyInputs */

const en_analytics_board_empty = /** @type {(inputs: Analytics_Board_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No board data yet. Apply to jobs to see response rates.`)
};

const de_analytics_board_empty = /** @type {(inputs: Analytics_Board_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch keine Board-Daten. Bewirb dich, um Antwortquoten zu sehen.`)
};

const fr_analytics_board_empty = /** @type {(inputs: Analytics_Board_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune donnée de site pour le moment. Postule pour voir les taux de réponse.`)
};

const es_analytics_board_empty = /** @type {(inputs: Analytics_Board_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aún no hay datos de portales. Postúlese para ver las tasas de respuesta.`)
};

const it_analytics_board_empty = /** @type {(inputs: Analytics_Board_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun dato sulle piattaforme ancora. Candidati per vedere i tassi di risposta.`)
};

const nl_analytics_board_empty = /** @type {(inputs: Analytics_Board_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nog geen platformgegevens. Solliciteer om responspercentages te zien.`)
};

const pl_analytics_board_empty = /** @type {(inputs: Analytics_Board_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brak danych o portalach. Aplikuj, aby zobaczyć wskaźniki odpowiedzi.`)
};

const fi_analytics_board_empty = /** @type {(inputs: Analytics_Board_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ei vielä sivustotietoja. Hae työpaikkoja nähdäksesi vastausprosentit.`)
};

const da_analytics_board_empty = /** @type {(inputs: Analytics_Board_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen portaldata endnu. Ansøg til job for at se svarprocenter.`)
};

const sv_analytics_board_empty = /** @type {(inputs: Analytics_Board_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen portaldata ännu. Ansök till jobb för att se svarsfrekvenser.`)
};

/**
* | output |
* | --- |
* | "No board data yet. Apply to jobs to see response rates." |
*
* @param {Analytics_Board_EmptyInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const analytics_board_empty = /** @type {((inputs?: Analytics_Board_EmptyInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Analytics_Board_EmptyInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_analytics_board_empty(inputs)
	if (locale === "fr") return fr_analytics_board_empty(inputs)
	if (locale === "es") return es_analytics_board_empty(inputs)
	if (locale === "it") return it_analytics_board_empty(inputs)
	if (locale === "nl") return nl_analytics_board_empty(inputs)
	if (locale === "pl") return pl_analytics_board_empty(inputs)
	if (locale === "fi") return fi_analytics_board_empty(inputs)
	if (locale === "da") return da_analytics_board_empty(inputs)
	if (locale === "sv") return sv_analytics_board_empty(inputs)
	return en_analytics_board_empty(inputs)
});